import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, filter, first, map, pairwise, Subscription, tap } from 'rxjs';

import * as fromOpportunity from '@amfam/opportunities';
import { OpportunitiesLoadAction } from '@amfam/opportunities';
import { routerQuery } from '@amfam/shared/utility/navigation';
import {
  OpportunityContentWithRecommendationId,
  OpportunitySlide
} from '@amfam/shared/utility/shared-services';

@Injectable({ providedIn: 'root' })
export class OverviewService {
  upsellsSubscription: Subscription;

  constructor(private store: Store) {}

  getDisclaimers(opportunitiesContent: OpportunityContentWithRecommendationId[]): string[] {
    if (!opportunitiesContent) return [];

    const slides: OpportunitySlide[] = [].concat(
      ...opportunitiesContent.map(content => content.slides)
    );
    const disclaimers = [].concat(...slides.map(slide => slide.disclaimers || []));

    return disclaimers;
  }

  loadUpsellsWhenNoCrossels() {
    if (!this.upsellsSubscription) {
      this.upsellsSubscription = combineLatest([
        this.store.select(fromOpportunity.selectOpportunitiesNoDismissed),
        this.store.select(routerQuery.getRouterCurrentStateUrl)
      ])
        .pipe(
          filter(([, url]) => url === '/overview'),
          map(([opps, _]) => opps),
          pairwise(),
          filter(([previous, current]) => previous?.length > 0 && current?.length === 0),
          first(),
          tap(() => {
            // Fetching upsells when no more crossels are remaining
            this.store.dispatch(OpportunitiesLoadAction());
          })
        )
        .subscribe();
    }
  }
}
